import { Currency, ValidatorsProps } from '@ui/src';

export interface TariffLog {
  id: string;
  action: string;
  user: string;
  date: string;
}

export interface TariffValidators {
  toggleActiveSchema: ValidatorsProps;
  batchToggleActiveSchema: ValidatorsProps;
  createTariffSchema: ValidatorsProps;
  createActiveDefaultSchema: ValidatorsProps;
  toggleActiveTariffSchema: ValidatorsProps;
  tariffAssignFeeSchema: ValidatorsProps;
}

export enum TariffType {
  INDIVIDUAL = 'INDIVIDUAL',
  CORPORATE = 'CORPORATE',
}

export enum TariffStatus {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export enum TariffAction {
  NONE = 'NONE',
  REPLACE_ALL = 'REPLACE_ALL',
  REPLACE_ALL_AND_ARCHIVE_PREVIOUS = 'REPLACE_ALL_AND_ARCHIVE_PREVIOUS',
  REPLACE_WITHOUT_CUSTOM_FEES = 'REPLACE_WITHOUT_CUSTOM_FEES',
}

export enum FeeAmountTypeEnum {
  FIXED = 'FIXED',
  PERCENT = 'PERCENT',
}

export interface TariffItemFee {
  name: string;
  fee?: {
    feeType: string;
  };
  feePercentAmount: number;
  feeFixedAmount: number;
  feePercentMinAmount: number;
  feePercentMaxAmount: number;
  feeAmountType: string;
  feeTargetAccountNumber: string;
  feeCurrencyId?: string;
  cascadeCurrencies?: Currency[];
  feeCascadeCurrenciesIds?: string[];
  tariffId: string;
  feeId: string;
  id: string;
  writeOffValue?: string;
  url?: string;
  render?: Record<string, React.JSX.Element>;
}

export interface TariffItem {
  name: string;
  type: string;
  status: TariffStatus;
  isActive: boolean;
  isDefault: boolean;
  riskScoreRangeId: string;
  id: string;
  fees: TariffItemFee[];
  url?: string;
  render?: Record<string, React.JSX.Element>;
}

export interface TariffFormValues {
  type: string;
  name: string;
  riskScoreRangeId: string;
}

export interface TariffFeeFormValues {
  feeId?: string;
  name: string;
  feeTargetAccountNumber?: string;
  feePercentAmount?: number;
  feeFixedAmount?: number;
  feePercentMinAmount?: number | null;
  feePercentMaxAmount?: number | null;
  feeAmountType: string;
  feeCurrencyId?: string;
  feeCascadeCurrenciesIds?: string[];
}

export interface UpdateTariffFormValues {
  type?: string;
  name?: string;
  riskScoreRangeId?: string;
}

export enum RiskScoreEnum {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export enum TariffPublishOptionEnum {
  WITHOUT_REPLACEMENT = 'WITHOUT_REPLACEMENT',
  REPLACE_FOR_ALL = 'REPLACE_FOR_ALL',
  REPLACE_AND_ACRHIVE_FOR_ALL = 'REPLACE_AND_ACRHIVE_FOR_ALL',
  REPLACE_FOR_ALL_CUSTOMIZED = 'REPLACE_FOR_ALL_CUSTOMIZED',
}

export interface FeeFormValues {
  feeId: string;
  name: string;
  feeTargetAccountNumber: string;
  feePercentAmount?: number;
  feeFixedAmount?: number;
  feePercentMinAmount?: number;
  feePercentMaxAmount?: number;
  feeAmountType: string;
  feeCurrencyId?: string;
  feeCascadeCurrenciesIds?: string[];
}
